var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.405 15.16c-4.152 0-7.53-3.377-7.53-7.529S4.253.101 8.405.101s7.53 3.378 7.53 7.53-3.378 7.53-7.53 7.53m0-13.803A6.28 6.28 0 0 0 2.13 7.63a6.28 6.28 0 0 0 6.275 6.275 6.28 6.28 0 0 0 6.274-6.275 6.28 6.28 0 0 0-6.274-6.274m3.137 6.274a.627.627 0 0 0-.627-.627H9.032V3.866a.627.627 0 1 0-1.255 0v3.765c0 .347.281.628.628.628h2.51c.347 0 .627-.28.627-.628"
  })));
};
export default SvgTime;